var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenclaw = function SvgOpenclaw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 500 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f4f4",
    fillRule: "evenodd",
    d: "M166.5 52.5h7q2.75 2.99 1.5 7-21.27 45.61-20.5 96 39.99 2.76 72 26.5 7.87 6.86 13.5 15.5 42.88-56.39 103.5-92.5 47.35-25.46 101-25 14.52.38 23.5 11.5 3.19 7.74 2 16-1.81 7.18-4.5 14-1 0-1 1-5.04 6.05-9 13-1 0-1 1v1q-12.42 12.15-28.5 19-6.02 36.27-41.5 45-.83 2.75 0 5 19.02-12.85 41.5-9 10.85-8.09 23.5-13 15.01-6.37 31-2.5 14.09 7.43 14 23.5-2.83 23.25-15.5 43-6.42 9.92-14 19-10.04 8.8-19.5 18-72.02 48.88-156.5 27-19.63 9.6-41.5 10.5-4.59 1.27-9 3l4 2q20.09-1.11 35 12 25.46 6.95 37.5 30.5 1.26 5.69-1 11-3.38 3.79-7.5 6.5 5.74 10.07 1.5 20.5-7.55 7.47-17.5 3.5-11.01-5.34-22.5-9.5-18.26 10-38.5 13h-31q-26.62-4.54-51-17-4.17 1.33-8 3.5-7.23 5.87-15 11-8.62 2.58-13.5-4.5-1.82 2.32-4.5 3.5-6.06 2.24-12 3.5h-15q-27.42-2.56-50-18.5-18-17.25-23-41.5v-23q4.12-22.7 25-33 6.95-16.67 22-26.5-20.39-20.8-14.5-49.5 7.01-26.98 28.5-44.5 7.56-5.27 15-10.5-13.09-30.88-7.5-64Q78.16 88.93 89.5 78q6.85-2.48 8 4.5-6.59 39.53 11 75.5 7.99-.49 16-2 2.42-34.57 14.5-67.5 8.51-22.23 27.5-36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b0303",
    fillRule: "evenodd",
    d: "M113.5 401.5q.48-5.1-1-10-.91.19-1 1-2.46 1.74-5 3.5 5.65 9.54-5 13-32.21 5.55-61-10Q7.61 375.89 11 335.5q2.96-22.67 23.5-32 7.99-19.75 27-29.5-27.65-23.7-15.5-58.5 7.33-16.82 20.5-29.5 10.79-8.14 22-15.5-16.49-37.08-5.5-76 3.19-6.13 7.5-11.5 1.48-.89 2 1-5.69 41.09 12.5 78.5l2 2q9.97-3.24 20.5-4h4v-15q.99-42.22 24.5-77 6.12-7.12 14-12-4.65 13.43-10 27-11.93 37.6-9.5 77 49.38.7 83.5 36l5.5 9q38.99-52.24 93-88.5 45.84-29.03 100-32.5 15.69-1.56 29 6.5 5.68 7.29 3.5 16.5-10.38 33.62-43.5 45-4.39 37.33-41 45-.79 8.63-6 15.5 1.91 1.83 4.5 2.5 22.27-17.25 50.5-14.5 12.93-9.41 28-15 36.22-8.28 31.5 28.5-15.19 51.69-62.5 77.5-65.92 35.87-138 15.5-19.67 10.42-42 10.5-8.39 2.88-17 5 3.58 6.08 10 9 20.92-1.14 36 13 22.67 5.23 34.5 25.5 3.33 7.13-3.5 11.5-3.88 1.8-8 3 7.36 8.45 6.5 19.5-4.43 5.66-11.5 3.5-12.84-5.67-26-10.5-39.4 21.02-83 10.5-18.85-5.78-36.5-14.5-13.65 4.14-23.5 14.5-9.51 3.74-11-6.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef0011",
    fillRule: "evenodd",
    d: "M153.5 173.5q24.62 1.46 46 13.5 12.11 8.1 17.5 21.5.74 2.45.5 5 .09.81 1 1 1.48-4.9 1-10 5.04 10.48 1.5 22-9.81 27.86-35.5 42.5-26.17 14.97-56 19.5-2.77-.4-2 1 2.86 1.27 6 1 25.64 1.53 48.5-10 .34 10.08 2 20 1.08 5.76 5 10 1 1.5 0 3-31.11 20.84-68.5 17.5-23.7-5.7-32.5-28.5-4.39-9.18-3.5-19 15.41 6.23 32 4.5-20.68-6.39-39-18-34.81-27.22-12.5-65.5 11.84-14.83 29-23 4.21 7.66 11.5 12.5 3 1 6 0-26.04-34.62-29-78-.13-8.46 2-16.5l2 13q3.43 39.53 24.5 73 2.03 2.28 4.5 4l1-2.5q-1.27-6.54-5-12l1-1.5q9.72-3.43 20-4 .55 10.34 8 17.5 1.94.74 4 .5-17.8-64.6 16.5-122 .98-1.79 1.5 0-28.21 56.64-13.5 118 1.08 1.43 2.5.5 2.21-4.98 2-10.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3e2e2",
    fillRule: "evenodd",
    d: "M454.5 97.5q-18.37-2.97-37-1.5-16.14 2.08-32 5.5 32.38-14.09 67-7.5 1.98 1.22 2 3.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f00212",
    fillRule: "evenodd",
    d: "M454.5 97.5q-1.33 11.18-8.5 20-21.81 26.28-55.5 32-1.11-.2-2 .5 2.31 2.82 5.5 4.5 1 2 0 4-9.56 11.3-19.5 20 19.71-8.72 31-27 2.68-.43 5 1-14.24 30.97-48 36.5-9.93 1.71-20 1.5-6.8-.48-13 1 5.81 6.92 14 11-10.78 16.03-27 26.5 27.16-7.4 38-33.5 4.34 1.35 9 1-9.08 23.84-33 33.5-18.45 6.41-38 7 22.59 8.92 45-1 12.05-5.52 24-11 9.01-1.79 17 2.5 5.28-4.38 11-8 12.8-6.07 27-5v1q-19.34 2.69-34 15.5l1 .5q17.79-8.09 36-15 2.71-.79 5-2l5-2q5.53-4.04 11-8 11.7-4.18 24-6.5 7.78-1.36 15 1.5-2.97 18.45-13.5 34-34.92 49.37-94.5 62.5-59.27 12.45-108-23-15.53-12.52-21.5-31.5-2.47-14.26 4-27-3.15 24.41 14 42-4.92-10.28-7-22-1.97-17.63 7-33 47.28-69.5 125.5-100 15.86-3.42 32-5.5 18.63-1.47 37 1.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba000d",
    fillRule: "evenodd",
    d: "m86.5 112.5-2-13q.7-5.34 3.5-10-1.8 11.32-1.5 23"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#faf1f1",
    fillRule: "evenodd",
    d: "M433.5 97.5q2.22-.39 4 1-10 13.75-27 14-.24-2.06.5-4 10.3-7.78 22.5-11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b0100",
    fillRule: "evenodd",
    d: "M407.5 101.5q2.55-.24 5 .5-52.87 18.31-84.5 64.5-6.94 7.95-17 11-9.38-2.38-5-11 40.38-48.62 101.5-65"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbedee",
    fillRule: "evenodd",
    d: "M402.5 112.5h6q-2.56 8.8-12 7-.22-1.58.5-3 2.72-2.22 5.5-4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#faeaea",
    fillRule: "evenodd",
    d: "M390.5 149.5q7.77.52 15 2-11.29 18.28-31 27 9.94-8.7 19.5-20 1-2 0-4-3.19-1.68-5.5-4.5.89-.7 2-.5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ab797d",
    fillRule: "evenodd",
    d: "M131.5 145.5v15h-4q1.06-1.36 3-1-.48-7.29 1-14"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8eaea",
    fillRule: "evenodd",
    d: "m219.5 204.5-2 9q.24-2.55-.5-5-5.39-13.4-17.5-21.5-21.38-12.04-46-13.5v-4q36.7-.86 61.5 26 3.06 4.11 4.5 9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#902021",
    fillRule: "evenodd",
    d: "M329.5 191.5q6.2-1.48 13-1l-7 2q-2.9-.97-6-1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9eeee",
    fillRule: "evenodd",
    d: "M329.5 191.5q3.1.03 6 1 9.55 1.31 19 3-10.84 26.1-38 33.5 16.22-10.47 27-26.5-8.19-4.08-14-11"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6ecec",
    fillRule: "evenodd",
    d: "M479.5 199.5q-7.22-2.86-15-1.5-12.3 2.32-24 6.5 15.6-13.11 36-11.5 3.63 2.26 3 6.5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#080201",
    fillRule: "evenodd",
    d: "M193.5 216.5q-12.01 1.52-22 8-2.83 1.29-5.5 3-4.79-4.57-6.5-11-5.04 2.2-9.5-1-3.47-6.4 3.5-3 4.4.05 8-2.5 9.22-9.73 21-16 6.3-3.24 12 1-2.9 1.22-6 1.5 2.61 5.74 4.5 12 .75 3.97.5 8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#150100",
    fillRule: "evenodd",
    d: "M458.5 200.5q3.04-.24 6 .5-18.02 7.05-33 19-1 1-2 0 11.53-14.3 29-19.5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2e7e7",
    fillRule: "evenodd",
    d: "M178.5 202.5q6.85-.63 4.5 6-7.6 5.09-6-4 1.08-.82 1.5-2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbe7e8",
    fillRule: "evenodd",
    d: "M469.5 201.5q-2.26 13.65-14.5 22-.47-2.11 1-4 7.08-8.82 13.5-18"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#060101",
    fillRule: "evenodd",
    d: "M74.5 208.5q8.22-.2 16 2.5 11.8 4.26 23.5 8.5 5.65-.63 8-6 2.41 11.83-9.5 13 .55 3.61 2 7l-1 2q-4.67-.94-9.5-1-9.96.44-19.5 2.5-5.05-3.55-6.5-9.5-.75-7.48-.5-15-6.47.15-3-4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5e7e7",
    fillRule: "evenodd",
    d: "m429.5 212.5-5 2h-8q-14.2-1.07-27 5 15.27-12.44 35-9.5 2.72 1.14 5 2.5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fa999e",
    fillRule: "evenodd",
    d: "M219.5 204.5q.48 5.1-1 10-.91-.19-1-1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#c46064",
    fillRule: "evenodd",
    d: "M416.5 215.5v-1h8q-2.29 1.21-5 2-1.06-1.36-3-1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#180300",
    fillRule: "evenodd",
    d: "M416.5 215.5q1.94-.36 3 1-18.21 6.91-36 15l-1-.5q14.66-12.81 34-15.5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6dcdd",
    fillRule: "evenodd",
    d: "M193.5 216.5q4.39 1.3 9 3-.79 1.04-2 1.5-14.77-.13-29 3.5 9.99-6.48 22-8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2e6e6",
    fillRule: "evenodd",
    d: "M98.5 219.5q6.09-.98 6 5-3.04.24-6-.5-1.84-2.24 0-4.5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#110200",
    fillRule: "evenodd",
    d: "M176.5 229.5q8.85-1.14 16 4-4.98 1.75-10 0-13.56 14.3-33 19.5-28.06 8.2-55 1 3.32-6.4 10-5.5-.71 1.47-2 2.5 36.58 4.24 69-14 4.68-2.13 1-5 2.35-.91 4-2.5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb0011",
    fillRule: "evenodd",
    d: "M231.5 238.5q1.31-.2 2 1-3.13 28.62 15 51-16.25 6.75-27-7.5-1-1-2 0 14.73 29.34 46 18.5 1.79.52 0 1.5-37.63 16.82-50.5-22.5-5.1-26.48 16.5-42"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#e20010",
    fillRule: "evenodd",
    d: "M243.5 259.5q5.88 3.62 10.5 9 12.96 18.46 32.5 29.5-31.51-7.75-43-38.5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea0011",
    fillRule: "evenodd",
    d: "M203.5 266.5q1.31-.2 2 1-2.48 22.08 12 39-6.99 1.35-14 .5 4.59 4.08 10 7-8.71.28-14.5-6.5-16.98-22.76 4.5-41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb0011",
    fillRule: "evenodd",
    d: "M58.5 284.5q9.6-2.17 14.5 6 5.15 14.18-1 28-11.05-13.14-27.5-17.5 5.15-9.9 14-16.5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#760007",
    fillRule: "evenodd",
    d: "m129.5 288.5 4 2q-3.14.27-6-1-.77-1.4 2-1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#f00514",
    fillRule: "evenodd",
    d: "M56.5 313.5q3.43 5.43 8 10-4.88.44-8 4-1.11-.2-2 .5 28.91 1.65 38 28.5.45 3.16-1 6-11.02-7.01-23-12.5l-9.5-7.5q1.47 7.42 7 13 8.34 27.18 32 43 .99 2.41-1.5 3.5-40.25 5.58-66.5-25.5-15.67-22.01-8-48 10.46-23.87 34.5-15"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcebeb",
    fillRule: "evenodd",
    d: "M45.5 317.5q4.03-.25 8 .5 2.46 4.16-2 6-6.04 2.01-9-3.5 1.26-1.85 3-3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecd6d6",
    fillRule: "evenodd",
    d: "M56.5 313.5q4.91 3.14 9.5 7 .88 2.25-1.5 3-4.57-4.57-8-10"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5e3e3",
    fillRule: "evenodd",
    d: "M198.5 319.5q-11.1 11.56-27 15.5-15.75 4.88-32 2.5 28.81-3.69 54-18.5 2.65-.96 5 .5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#f00212",
    fillRule: "evenodd",
    d: "M198.5 319.5q1.44.68 2.5 2 2.41 8.23 6 16 1.2 2.64-.5 5-30.65 21.41-68 18.5-25.16-6.17-32.5-30.5 6.96 4.99 15.5 6.5 8.99.75 18 .5 16.25 2.38 32-2.5 15.9-3.94 27-15.5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5e4e4",
    fillRule: "evenodd",
    d: "M92.5 356.5q-9.09-26.85-38-28.5.89-.7 2-.5 25.47-4.89 35.5 19 .75 4.98.5 10"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#faf6f6",
    fillRule: "evenodd",
    d: "M72.5 335.5q3.62-.38 5 3-4.22 1.83-5-3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#e50010",
    fillRule: "evenodd",
    d: "M223.5 336.5q5.59-.48 11 1-4.04 4.16-8.5 8-5.99-3.8-2.5-9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#d5000f",
    fillRule: "evenodd",
    d: "M90.5 334.5q.59-1.54 2-.5 3.94 5.45 9 10l14 12q-6.91-1.7-13-6-6.21-7.72-12-15.5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2e2e3",
    fillRule: "evenodd",
    d: "M261.5 346.5q-3.54-2.44-8-3.5-6.98-.75-14-.5.63-1.08 2-1.5 13.82-2.52 26 4-2.63 1.98-6 1.5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef1018",
    fillRule: "evenodd",
    d: "M239.5 342.5q7.02-.25 14 .5 4.46 1.06 8 3.5-5.2 2.35-10 5.5-3.88 4.65-9 7.5-9.89-3.09-9.5-13 2.36-3.63 6.5-4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4e8e9",
    fillRule: "evenodd",
    d: "M214.5 349.5q-21.43 15.48-48 16 22.82-5.9 43-18.5 3.64-1.12 5 2.5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef0513",
    fillRule: "evenodd",
    d: "M214.5 349.5q5.96 7.2 13.5 13 1 1 0 2-28.58 23.34-65.5 20.5-18.15-4.24-27.5-19.5 1.13.94 2.5 1.5 14.7 1.42 29-1.5 26.57-.52 48-16"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5e5e5",
    fillRule: "evenodd",
    d: "M302.5 373.5q-14.74-16.73-37-19-4.55.25-9 1 25.3-10.24 43.5 11 2.85 2.91 2.5 7"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#f00413",
    fillRule: "evenodd",
    d: "M302.5 373.5q.21 2.44-2 3.5-28.69 7.6-50.5-12.5-.06-6.71 6.5-9 4.45-.75 9-1 22.26 2.27 37 19"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4e9ea",
    fillRule: "evenodd",
    d: "m100.5 356.5 11 5.5q-13.04 7.54-18.5 21.5-7.57-7.14-10.5-17 5.58 1.54 10 5.5 4.2.84 5.5-3.5 1.41-5.99 2.5-12"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbedee",
    fillRule: "evenodd",
    d: "M83.5 394.5q-18.9-10.15-29.5-29-1.54-3.52-2-7 5.79 2.39 10 7 7.82 16.63 21.5 29"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed0011",
    fillRule: "evenodd",
    d: "M232.5 365.5q17.6 6.19 10.5 23-10.6 10.42-25.5 11.5-25.94 3.21-49-9 36.75-1.65 64-25.5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#e80011",
    fillRule: "evenodd",
    d: "M113.5 367.5q7.7-.01 9.5 7-9.69 7.19-18.5 15.5-7.23 5.76-5.5-3.5 3.12-12.84 14.5-19"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea0011",
    fillRule: "evenodd",
    d: "M126.5 380.5q7.88-.4 12 6.5l-17 14.5q-5.62-12.55 5-21"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#e60613",
    fillRule: "evenodd",
    d: "M283.5 385.5q3.22 2.95 7 5.5 2.8 4.03 6 7.5.42 2.77-2 4l-31-19.5q-1.79-.98 0-1.5 9.96 2.49 20 4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0d6d6",
    fillRule: "evenodd",
    d: "M283.5 385.5q8.71-1.27 11.5 7 1.22 2.9 1.5 6-3.2-3.47-6-7.5-3.78-2.55-7-5.5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#fca9ac",
    fillRule: "evenodd",
    d: "M83.5 394.5q1.88-.06 3 1.5-2.25.88-3-1.5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c000c",
    fillRule: "evenodd",
    d: "M258.5 392.5q3.51.41 0 2.5-2.33 1.93-5 2 2.61-2.28 5-4.5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#73393b",
    fillRule: "evenodd",
    d: "M111.5 392.5q.09-.81 1-1 1.48 4.9 1 10z"
  })));
};
export default SvgOpenclaw;